export class SiteContainerHeight {
    constructor() {
        //document.addEventListener("DOMContentLoaded", function (event) {
        //    let headerHeight = document.querySelector("#header").clientHeight + "px";
        //    let siteContainer = document.querySelector(".site-container") as HTMLElement;
        //    siteContainer.style.paddingTop = headerHeight;
        //});
    }
}



// WEBPACK FOOTER //
// ./Static/javascript/modules/site-container-height.ts